export default "/images/vendor/flag-icon-css/flags/1x1/bj.svg?bbb9c937317f682ba1f2b0c524470aa3";